module.exports = __webpack_public_path__ + "img/profile.013261f1.jpg";